import { defaultLanguage } from "../../helper/utility";
import { language } from "../../languageProvider/language/language";
import {
  LOGIN_JWT_SUCCESS,
  LOGOUT_JWT,
  TOGGLE_JWT_MODAL,
  LOGIN_JWT_FAIL,
  START_JWT_LOADING,
  GET_JWT_PROFILE,
  GET_JWT_PROFILE_FAIL,
  TOGGLE_USER_MODAL,
  SUCCESS_SIGNUP_JWT,
  REGISTER_JWT_FAIL,
  END_JWT_LOADING,
  UPDATE_PROFILE_SUCCESS,
  UPDATE_PROFILE_FAIL,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAIL,
  DELETE_ACCOUNT_SUCCESS,
  DELETE_ACCOUNT_FAIL,
  REQUEST_PASSWORD_RESET_SUCCESS,
  REQUEST_PASSWORD_RESET_FAIL,
  SET_LOGIN_MODAL_VIEW
} from "../type";

const AUTH_TOKENS_KEY = "inpublish_auth_tokens";
const AUTH_USER_KEY = "inpublish_auth_user";

const savedTokens = (() => {
  try {
    const stored = localStorage.getItem(AUTH_TOKENS_KEY);
    return stored ? JSON.parse(stored) : {};
  } catch {
    return {};
  }
})();

const savedUser = (() => {
  try {
    const stored = localStorage.getItem(AUTH_USER_KEY);
    return stored ? JSON.parse(stored) : null;
  } catch {
    return null;
  }
})();

const hasValidSession = savedTokens.jwtToken && savedTokens.expiresAt > Date.now() && savedUser;

const initState = {
  isAuthenticated: !!hasValidSession,
  modalJwtOpen: false,
  loading: false,
  user: savedUser,
  error: null,
  loadingProfile: !hasValidSession,
  modalUserOpen: false,
  success_signup: false,
  feedbackMessage: "",
  errorCode: null,
  // JWT tokens
  jwtToken: savedTokens.jwtToken || null,
  refreshToken: savedTokens.refreshToken || null,
  expiresAt: savedTokens.expiresAt || null,
  // Profile update
  profileUpdateLoading: false,
  profileUpdateError: null,
  profileUpdateSuccess: false,
  // Change password
  changePasswordLoading: false,
  changePasswordError: null,
  changePasswordSuccess: false,
  // Login modal view
  loginModalView: "login",
};

function authReducer(state = initState, action) {
  const { type, payload } = action;
  switch (type) {
    case START_JWT_LOADING:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case END_JWT_LOADING:
      return {
        ...state,
        loading: false,
      };
    case LOGIN_JWT_SUCCESS:
    case GET_JWT_PROFILE: {
      const userData = payload?.user || payload;
      if (payload?.jwtToken) {
        try {
          localStorage.setItem(AUTH_TOKENS_KEY, JSON.stringify({
            jwtToken: payload.jwtToken,
            refreshToken: payload.refreshToken,
            expiresAt: payload.expiresAt,
          }));
        } catch { /* ignore */ }
      }
      try {
        localStorage.setItem(AUTH_USER_KEY, JSON.stringify(userData));
      } catch { /* ignore */ }
      return {
        ...state,
        isAuthenticated: true,
        user: userData,
        loading: false,
        error: null,
        modalJwtOpen: false,
        loadingProfile: false,
        success_signup: false,
        jwtToken: payload?.jwtToken || state.jwtToken,
        refreshToken: payload?.refreshToken || state.refreshToken,
        expiresAt: payload?.expiresAt || state.expiresAt,
      };
    }
    case LOGIN_JWT_FAIL:
    case REGISTER_JWT_FAIL:
    case GET_JWT_PROFILE_FAIL:
      return {
        ...state,
        isAuthenticated: false,
        user: null,
        error: payload,
        loading: false,
        loadingProfile: false,
      };
    case SUCCESS_SIGNUP_JWT:
      return {
        ...state,
        success_signup: true,
        loading: false,
        error: null,
        feedbackMessage: language[defaultLanguage].registrazione_success,
      };
    case LOGOUT_JWT:
      try {
        localStorage.removeItem(AUTH_TOKENS_KEY);
        localStorage.removeItem(AUTH_USER_KEY);
      } catch { /* ignore */ }
      return {
        ...state,
        isAuthenticated: false,
        modalJwtOpen: false,
        loading: false,
        user: null,
        error: null,
        loadingProfile: false,
        modalUserOpen: false,
        jwtToken: null,
        refreshToken: null,
        expiresAt: null,
      };
    case TOGGLE_JWT_MODAL:
      return {
        ...state,
        modalJwtOpen: !state.modalJwtOpen,
      };
    case TOGGLE_USER_MODAL:
      return {
        ...state,
        modalUserOpen: !state.modalUserOpen,
      };
    case SET_LOGIN_MODAL_VIEW:
      return {
        ...state,
        loginModalView: payload,
      };
    case UPDATE_PROFILE_SUCCESS:
      return {
        ...state,
        user: { ...state.user, ...payload },
        profileUpdateLoading: false,
        profileUpdateError: null,
        profileUpdateSuccess: true,
      };
    case UPDATE_PROFILE_FAIL:
      return {
        ...state,
        profileUpdateLoading: false,
        profileUpdateError: payload,
        profileUpdateSuccess: false,
      };
    case CHANGE_PASSWORD_SUCCESS:
      return {
        ...state,
        changePasswordLoading: false,
        changePasswordError: null,
        changePasswordSuccess: true,
      };
    case CHANGE_PASSWORD_FAIL:
      return {
        ...state,
        changePasswordLoading: false,
        changePasswordError: payload,
        changePasswordSuccess: false,
      };
    case DELETE_ACCOUNT_SUCCESS:
      try {
        localStorage.removeItem(AUTH_TOKENS_KEY);
        localStorage.removeItem(AUTH_USER_KEY);
      } catch { /* ignore */ }
      return {
        ...initState,
        loadingProfile: false,
      };
    case DELETE_ACCOUNT_FAIL:
      return {
        ...state,
        error: payload,
      };
    case REQUEST_PASSWORD_RESET_SUCCESS:
      return {
        ...state,
        loading: false,
        loginModalView: "forgotPasswordSent",
      };
    case REQUEST_PASSWORD_RESET_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };
    default:
      return state;
  }
}

export default authReducer;
